import PropTypes from 'prop-types'
import Opiniones from './Opiniones'

import './CalificacionProducto.css'

const CalificacionProducto = (props) => {
  const arrayCalificacionPromedio = props.calificacion.map((e) => e.promedioCalificacion)
  const calificacionPromedio = arrayCalificacionPromedio[0]

  return (
    <div className="col">
      <p className="titulo-detalle">
        Opiniones del Producto &nbsp;
        <i className="fa fa-caret-right" aria-hidden="true"></i>
      </p>
      <div className="row informacion">
        <div className="col">
          <div className="row">
            <div className="col">
              <p className="puntuacion text-center ml-3">
                Puntuación Promedio:
                {calificacionPromedio}
                <i className="fa fa-star yellow-star ml-3" aria-hidden="true"></i>
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <p className="puntuacion text-center">Opiniones</p>
            </div>
            <div className="col-12 bordered">
              {props.calificacion.map((e) => (
                <Opiniones
                  key={e.idCalificacion}
                  calificacion={e.calificacionAlItem}
                  comentario={e.comentario}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CalificacionProducto.propTypes = {
  calificacion: PropTypes.arrayOf(
    PropTypes.shape({
      idCalificacion: PropTypes.number.isRequired,
      promedioCalificacion: PropTypes.number.isRequired,
      calificacionAlItem: PropTypes.number.isRequired,
      comentario: PropTypes.string.isRequired
    })
  ).isRequired
}

export default CalificacionProducto
